/* ODC Home — countdown to local midnight (offer bar) + "Mostra altre recensioni" (reviews).
   Same pad/tick logic as the approved mockup (_tools/odc_home/mockup/odc-hero-v1.html). Loaded with `defer` by the
   offer and reviews sections; idempotent (window.__odcHome guard, per-root init flag); re-inits on shopify:section:load. */
(function () {
  'use strict';
  if (window.__odcHome) return;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initTimer(root) {
    var h = root.querySelector('[data-odc-timer="h"]');
    var m = root.querySelector('[data-odc-timer="m"]');
    var s = root.querySelector('[data-odc-timer="s"]');
    if (!h || !m || !s) return;
    function tick() {
      var now = new Date(), end = new Date(now); end.setHours(23, 59, 59, 999);
      var d = Math.max(0, end - now);
      h.textContent = pad(Math.floor(d / 3600000));
      m.textContent = pad(Math.floor(d % 3600000 / 60000));
      s.textContent = pad(Math.floor(d % 60000 / 1000));
    }
    tick();
    root.__odcTimer = setInterval(tick, 1000);
  }

  function initMore(root) {
    var btn = root.querySelector('[data-odc-more]');
    var grid = root.querySelector('.oh-rgrid');
    if (!btn || !grid) return;
    btn.addEventListener('click', function () { grid.classList.add('oh-open'); });
  }

  function init(root) {
    if (!root || root.__odcHomeInit) return;
    root.__odcHomeInit = true;
    initTimer(root);
    initMore(root);
  }

  function destroy(root) {
    if (root.__odcTimer) { clearInterval(root.__odcTimer); root.__odcTimer = null; }
    root.__odcHomeInit = false;
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-odc-home]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  window.__odcHome = { init: init, initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var roots = e.target.querySelectorAll('[data-odc-home]');
    for (var i = 0; i < roots.length; i++) destroy(roots[i]);
  });
})();
